"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/image/index.ts
var image_exports = {};
__export(image_exports, {
  Image: () => Image_default,
  default: () => Image_default
});
module.exports = __toCommonJS(image_exports);
var import_index = require("./index.css");

// src/image/Image.tsx
var import_classnames = __toESM(require("classnames"));

// src/image/image.module.scss
var image_module_default = {
  "figureContainer": "image-module__figureContainer___jYA2e",
  "image": "image-module__image___vystJ",
  "figure-hasBorder": "image-module__figure-hasBorder___fP8EU",
  "figure-hasBoxShadow": "image-module__figure-hasBoxShadow___bqnjE",
  "figure-hasRoundedCorners": "image-module__figure-hasRoundedCorners___aJWq0"
};

// src/image/Image.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Image = ({
  src,
  altText = "",
  loading = "lazy",
  decoration = "none",
  hasRoundedCorners = true,
  style,
  className,
  onLoad,
  onError,
  ...ImageHTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "figure",
  {
    className: (0, import_classnames.default)(
      image_module_default.figureContainer,
      {
        [image_module_default["figure-hasBorder"]]: decoration === "border",
        [image_module_default["figure-hasBoxShadow"]]: decoration === "shadow",
        [image_module_default["figure-hasRoundedCorners"]]: hasRoundedCorners
      },
      className
    ),
    style,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "img",
      {
        className: (0, import_classnames.default)(image_module_default.image),
        alt: altText,
        loading,
        src,
        onLoad,
        onError,
        ...ImageHTMLAttributes
      }
    )
  }
);
var Image_default = Image;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Image
});
//# sourceMappingURL=index.js.map